

export const addEditInitialValues = {
  nationalRegistration: '',
  accountOwner: '',
  bank: '',
  bankName: '',
  agency: '',
  accountType: '',
  accountNumber: '',
  accountDigit: '',
  accountIdentifier: '',
  transactionType: '',
  pixKey: '',
  pixTypeKey: '',
  id: '',
}

export const accountBaseData = [
    {
      id: 1,
      label: 'Conta-Corrente',
      value: 'ccorrente'
    },
    {
      id: 2,
      label: 'Conta-Poupança',
      value: 'cpoupanca'
    },
  ]
export const reasonBaseData = [
    {
      id: 1,
      label: 'Motivo 01',
      value: 'motivo_01'
    },
    {
      id: 2,
      label: 'Motivo 02',
      value: 'motivo_02'
    },
    {
      id: 3,
      label: 'Motivo 03',
      value: 'motivo_03'
    },
  ]

export const transactionTypeOptions = [
  { id: 1, value: 'PIX', label: 'PIX' },
  { id: 2, value: 'TED', label: 'TED' },
];

export const temporaryBankList = [
    {
        id: 128,
        value: '246',
        label: 'Banco ABC Brasil S.A.'
      },
      {
        id: 129,
        value: '075',
        label: 'Banco ABN AMRO S.A.'
      },
      {
        id: 130,
        value: '025',
        label: 'Banco Alfa S.A.'
      },
      {
        id: 131,
        value: '641',
        label: 'Banco Alvorada S.A.'
      },
      {
        id: 132,
        value: '065',
        label: 'Banco AndBank (Brasil) S.A.'
      },
      {
        id: 133,
        value: '024',
        label: 'Banco BANDEPE S.A.'
      },
      {
        id: 134,
        value: '029',
        label: 'Banco Banerj S.A.'
      },
      {
        id: 135,
        value: '000',
        label: 'Banco Bankpar S.A.'
      },
      {
        id: 136,
        value: '740',
        label: 'Banco Barclays S.A.'
      },
      {
        id: 137,
        value: '107',
        label: 'Banco BBM S.A.'
      }
  ]